module.exports = __webpack_public_path__ + "img/正方形1.64dcd3b3.jpg";